import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import "./aplicacoesPlanoCadastro.css";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import {
  getAplicacaoPlanoById,
  getAplicacaoPlanoCadastro,
  getAplicacaoPlanoUpdate,
} from "../../services/api_cadastro_aplicacoes_plano";
import { getApplications } from "../../services/api_aplicacoes";
import getDateHour from "../../hooks/GetDateHour";
import { getDate } from "date-fns";

const AplicacoesPlanoRegister = () => {
  const location = useLocation();
  const id = location.state?.id;
  const idPlano = location.state?.idPlano;
  const nomePlano = location.state?.nomePlano;
  const [id_aplicacao, setAplicacao] = useState("");
  const [periodicidade, setPeriodicidade] = useState("");
  const [start_plano, setStartPlano] = useState("");
  const [aplicacao, setAplicacoes] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  //console.log(idPlano);
  //console.log(nomePlano);
  const POLLING_INTERVAL = 15000;

  const inputRefs = {
    Aplicacao: useRef(null),
    Periodicidade: useRef(null),
    startPlano: useRef(null),
  };

  useEffect(() => {
    const fetchAplicacaoPlano = async () => {
      try {
        const response = await getAplicacaoPlanoById(id);
        const aplicacao_plano = response.data.AplicacaoPlanoManutencao;
        if (aplicacao_plano) {
          setAplicacao(aplicacao_plano.id_aplicacao || "");
          setPeriodicidade(aplicacao_plano.periodicidade || "");
          setStartPlano(aplicacao_plano.start_plano);
        } else {
          console.error(
            "Dados da Aplicação não encontrados na resposta:",
            response
          );
        }
      } catch (error) {
        console.error("Erro ao obter dados da unidade:", error);
      }
    };

    if (id) {
      fetchAplicacaoPlano();
    } else {
    }
  }, [id]);

  useEffect(() => {
    const fetchAplicacao = async () => {
      try {
        const response = await getApplications();
        if (response) {
          const aplicacoesAtivas = response.data.Aplicacao.filter(
            (aplicacoes) => aplicacoes.deleted_at === null
          )
          setAplicacoes(aplicacoesAtivas);
          //console.log("informações aplicações", response);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };
    fetchAplicacao();
    const interval = setInterval(() => {
      fetchAplicacao();
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (!id_aplicacao || !periodicidade) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento dos campos Aplicação e Periodicidade são obrigatórios.",
      });
      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getAplicacaoPlanoCadastro(body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar aplicação:", response);
      }
    } catch (error) {
      console.error("Erro ao cadastrar empresa:", error);
    } finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUpdate = async (body) => {
    try {
      const response = await getAplicacaoPlanoUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao atualizar registro:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar a empresa:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    } finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        id_aplicacao,
        periodicidade,
        id_plano: idPlano,
        start_plano: start_plano === "" ? null : start_plano,
      };

      if (id) {
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === "Enter" && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus =
        nextFieldRef.current.inputRef || nextFieldRef.current;

      if (typeof elementToFocus.focus === "function") {
        elementToFocus.focus();
      } else {
        console.warn("O elemento de input não tem o método focus.");
      }
    }
  };

  const handleClear = () => {
    setStartPlano("")
  }

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Cadastros / Cadastro Aplicações do Plano" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form className="mt-4">
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formAplicacao">
                  <Form.Label>Aplicação</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_aplicacao}
                    onChange={(e) => setAplicacao(e.target.value)}
                    ref={inputRefs.Aplicacao}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Periodicidade)}
                    required
                  >
                    <option value="">Selecione</option>
                    {aplicacao &&
                      aplicacao.map((id_aplicacao) => (
                        <option key={id_aplicacao.id} value={id_aplicacao.id}>
                          {id_aplicacao.descricao}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formPeriodicidade">
                  <Form.Label>Periodicidade</Form.Label>
                  <Form.Control
                    type="number"
                    value={periodicidade}
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      setPeriodicidade(value >= 0 ? value : 0);
                    }}
                    ref={inputRefs.Periodicidade}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.startPlano)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formStartPlano">
                  <Form.Label>Start do Plano</Form.Label>
                  <div className="input-group">
                    <Form.Control
                      type="date"
                      value={start_plano}
                      onChange={(e) => setStartPlano(e.target.value)}
                      ref={inputRefs.startPlano}
                      required
                    />
                    <Button
                      onClick={handleClear}
                    >
                      <FontAwesomeIcon icon={faClose} />
                    </Button>
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default AplicacoesPlanoRegister;
